export const phone_lists = {
  modal: {
    remove: {
      content: `Anda yakin ingin menghapus daftar <b>{name}<b>?`
    }
  },

  form: {
    title: {
      edit: {
        main: 'Daftar Data Nomor',
        add_phone: 'Tambah Nomor',
        added_phones: 'Nomor telepon ditambahkan'
      }
    },

    state: {
      add: 'Ditambahkan',
      remove: 'Hapus'
    },

    field: {
      name: 'Nama',
      phone: 'Nomor',
      state: 'Negara'
    }
  }
};
